import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errMsg } from "../../lib/api";
import { SNAPSHOT, SnapshotNotice } from "../../lib/snapshot";

const EMPTY = { company: "", contact_name: "", email: "", phone: "", website: "", message: "", consent: false };

const F = ({ id, label, required, children }) => (
  <div><label htmlFor={id} className="field-label">{label}{required && <span className="text-burgundy" aria-hidden="true"> *</span>}</label>{children}</div>
);

export default function EnquiryDialog({ open, onOpenChange, packages, packageId }) {
  const [form, setForm] = useState(EMPTY);
  const [pkg, setPkg] = useState(packageId);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  useEffect(() => { if (open) { setPkg(packageId); setDone(null); } }, [open, packageId]);
  const set = (k) => (e) => setForm({ ...form, [k]: k === "consent" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.post("/public/sponsor-enquiries", { ...form, package_id: pkg }); setDone(data); setForm(EMPTY); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-xl overflow-y-auto" data-testid="sponsor-enquiry-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-navy">Sponsorship Enquiry</DialogTitle>
          <DialogDescription>Tell us about your organization and we will be in touch.</DialogDescription>
        </DialogHeader>
        {done ? (
          <p role="status" className="rounded bg-paleblue p-4 text-navy" data-testid="sponsor-enquiry-success">Thank you. Your enquiry for the <b>{done.package_name}</b> package has been received.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="sponsor-enquiry-form">
            <SnapshotNotice />
            <F id="sp-package" label="Package" required>
              <select id="sp-package" className="field-input" value={pkg} onChange={(e) => setPkg(e.target.value)} data-testid="sponsor-package-select">
                {packages.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
                <option value="custom">Custom Sponsorship</option>
              </select>
            </F>
            <F id="sp-company" label="Company" required><input id="sp-company" required className="field-input" value={form.company} onChange={set("company")} data-testid="sponsor-company-input" /></F>
            <div className="grid gap-4 sm:grid-cols-2">
              <F id="sp-contact" label="Contact name" required><input id="sp-contact" required className="field-input" value={form.contact_name} onChange={set("contact_name")} data-testid="sponsor-contact-input" /></F>
              <F id="sp-email" label="Email" required><input id="sp-email" type="email" required className="field-input" value={form.email} onChange={set("email")} data-testid="sponsor-email-input" /></F>
              <F id="sp-phone" label="Phone"><input id="sp-phone" type="tel" className="field-input" value={form.phone} onChange={set("phone")} data-testid="sponsor-phone-input" /></F>
              <F id="sp-web" label="Website"><input id="sp-web" type="url" className="field-input" value={form.website} onChange={set("website")} placeholder="https://" data-testid="sponsor-website-input" /></F>
            </div>
            <F id="sp-msg" label="Message"><textarea id="sp-msg" rows={4} className="field-input" value={form.message} onChange={set("message")} data-testid="sponsor-message-input" /></F>
            <label className="flex items-start gap-3 text-sm"><input type="checkbox" required className="mt-1 h-4 w-4" checked={form.consent} onChange={set("consent")} data-testid="sponsor-consent-checkbox" />
              I consent to CIArb Bahamas Branch storing these details to respond to my enquiry.</label>
            <button type="submit" className="btn-primary w-full" disabled={busy || SNAPSHOT} data-testid="sponsor-enquiry-submit-btn">{busy ? "Sending…" : "Send Enquiry"}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
